import React, { useContext } from 'react';
import { orgId, baseUrl } from 'utils';
import { I18N, GlobalContext } from 'commons';

const Banner = () => {
  const { organization: { orgName = '', hasBanner },
    commsData: {
      orgId: orgIdFromCommsData
    } } = useContext(GlobalContext);

  const getSrc = () => {
    if (orgIdFromCommsData) {
      return `${baseUrl}/${orgIdFromCommsData}/banner`;
    }
    return `${baseUrl}/${orgId}/banner`;
  };
  return (
    <header>
      {hasBanner ? (
        <div className="container banner">
          <I18N
            tag="img"
            className="img-fluid"
            src={getSrc()}
            alt={orgName ? `welcome.h3, ${orgName}` : ''}
            i18n-alt={`welcome.h3, ${orgName}`}
            i18n-title={`welcome.h3, ${orgName}`}
          />
        </div>
      ) : (
        <div className="container banner no-image">
          <I18N tag="strong" i18n-title="">
            {`welcome.h3, ${orgName}`}
          </I18N>
        </div>
      )}
    </header>
  );
};


export default Banner;
